import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LandingPagesComponent } from './landing-pages.component'
import { GuestLandingPageComponent } from './guest-landing-page/guest-landing-page.component'
import { LoggedinHomePageComponent } from './loggedin-home-page/loggedin-home-page.component'
import { QuickTrackingWidgetComponent } from './guest-landing-page/quick-tracking-widget/quick-tracking-widget.component'
import { ProductLinesComponent } from './guest-landing-page/product-lines/product-lines.component'
import { RegisterSectionComponent } from './guest-landing-page/register-section/register-section.component'
import { FeaturedProductSectionComponent } from './guest-landing-page/featured-product-section/featured-product-section.component'
import { ContactUsSectionComponent } from './guest-landing-page/contact-us-section/contact-us-section.component'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { QuickLinksComponent } from './loggedin-home-page/quick-links/quick-links.component'
import { CompanyProfileComponent } from './loggedin-home-page/company-profile/company-profile.component'
import { FeaturedProductsComponent } from './loggedin-home-page/featured-products/featured-products.component'
import { AdditionalResourcesComponent } from './loggedin-home-page/additional-resources/additional-resources.component'
import { BhCarouselComponent } from './loggedin-home-page/bh-carousel/bh-carousel.component'
import { CheckPriceAvailabilityComponent } from './loggedin-home-page/check-price-availability/check-price-availability.component'
import { LandingPagesService } from './landing-pages.service'
import { DIALOG_TYPE, SpinnerModule } from '@spartacus/storefront'
import { AddToCartModule } from '../cart/add-to-cart/add-to-cart.module'
import { CreateOrderWidgetComponent } from './loggedin-home-page/create-order-widget/create-order-widget.component'
import { BulkOrderModule } from '../bulk-order/bulk-order.module'
import { OutagePopupNotificationComponent } from './outage-popup-notification/outage-popup-notification.component'
import { ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DatePickerModule } from '../../shared/components/date-picker/date-picker.module'
import { environment } from '../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'

@NgModule({
  declarations: [
    LandingPagesComponent,
    GuestLandingPageComponent,
    LoggedinHomePageComponent,
    QuickTrackingWidgetComponent,
    ProductLinesComponent,
    RegisterSectionComponent,
    FeaturedProductSectionComponent,
    ContactUsSectionComponent,
    QuickLinksComponent,
    CompanyProfileComponent,
    FeaturedProductsComponent,
    AdditionalResourcesComponent,
    BhCarouselComponent,
    CheckPriceAvailabilityComponent,
    CreateOrderWidgetComponent,
    OutagePopupNotificationComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    DatePickerModule,
    SpinnerModule,
    FormsModule,
    AddToCartModule,
    BulkOrderModule,
    I18nModule,
    NgSelectModule,
    MatTooltipModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['landing'],
        },
      },
    }),
  ],
  providers: [
    LandingPagesService,
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.OUTAGE_NOTIFICATION]: {
          inlineRoot: true,
          component: OutagePopupNotificationComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class LandingPagesModule {}
